module.exports = __webpack_public_path__ + "static/media/jiyeon_han.77a9e0bc.png";